<template>
  <main class="app-content">
    <div class="app-title">
      <div class="row">
        <div class="col-md">
          <h1><i class="fa fa-dashboard"></i>{{ $t('overview') }}</h1>
        </div>
        <div class="col-md">
          <time-range-picker :model="filterFormModel" :label="$t('time')" @change="getCount"
                             :defaultShortcut="0"></time-range-picker>
        </div>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item">
          <router-link to="/">Dashboard</router-link>
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon">
            <font-awesome-icon icon="handshake"/>
          </div>
          <div class="info">
            <h4>Client</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.client }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineClient }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small info coloured-icon">
          <div class="icon">
            <i class="fa fa-user-plus"></i>
          </div>
          <div class="info">
            <h4>{{ $t('user') }}</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.user }}</b></p>
            <p><span>{{ $t('online') }}: </span><b>{{ count.onlineUser }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3" v-if="$store.state.user.role !== 'agency'">
        <div class="widget-small warning coloured-icon">
          <div class="icon">
            <font-awesome-icon icon="bullhorn"/>
          </div>
          <div class="info">
            <h4>{{ $t('callCampaign') }}</h4>
            <p><span>{{ $t('new') }}: </span><b>{{ count.callCampaignNew }}</b></p>
            <p><span>{{ $t('callCampaignActive') }}: </span><b>{{ count.callCampaignActive }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3" v-if="$store.state.user.role !== 'agency'">
        <router-link to="/report/call">
          <div class="widget-small danger coloured-icon">
            <div class="icon">
              <font-awesome-icon icon="headphones-alt"/>
            </div>
            <div class="info">
              <h4>{{ $t('call') }}</h4>
              <p><span>{{ $t('total') }}: </span><b>{{ count.callTotal }}</b></p>
              <p><span>{{ $t('connected') }}: </span><b>{{ count.callSuccess }}</b></p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="row" v-if="$store.state.user.role !== 'agency'">
      <div class="col-md-6 col-lg-3">
        <router-link to="/report/customer">
          <div class="widget-small primary coloured-icon">
            <div class="icon">
              <font-awesome-icon icon="users"/>
            </div>
            <div class="info">
              <h4>Customer</h4>
              <p><b>{{ count.customer }}</b></p>
            </div>
          </div>
        </router-link>
      </div>
      <div class="col-md-6 col-lg-3">
        <div class="widget-small danger coloured-icon">
          <div class="icon">
            <font-awesome-icon icon="server"/>
          </div>
          <div class="info">
            <h4>{{ $t('opportunity') }}</h4>
            <p><b>{{ count.opportunity }}</b></p>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-3">
        <a href="#">
          <div class="widget-small danger coloured-icon">
            <div class="icon">
              <font-awesome-icon icon="dollar-sign"/>
            </div>
            <div class="info">
              <h4>{{ $t('finance') }}</h4>
              <p><span>{{ $t('deposit') }}: </span><b>{{ count.deposit | numFormat }}</b></p>
              <p><span>{{ $t('spent') }}: </span><b>{{ count.spent | numFormat }}</b></p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="raw row">
      <div class="col-12 py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">{{ $t('fee') }}</h4>
        <div class="row">
          <div class="col-md-4 col-lg-4 mt-1">
            <div>
              <span>{{ $t('viberFee') }}: </span><b v-if="viberFee">{{ viberFee | numFormat }}</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
            <div>
              <span>{{ $t('znsFee') }}: </span><b v-if="znsFee">{{ znsFee | numFormat }}</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
            <div>
              <span>{{ $t('aiFee') }}: </span><b v-if="aiFee">{{ aiFee | numFormat }}</b><b v-else>{{ $t('notSet') }}</b>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 mt-1">
            <div>
              <span>Giá gói cước thoại trọn gói/tháng: </span><b v-if="planFee">{{ planFee | numFormat }}</b><b v-else>{{ $t('notSet') }}</b>
            </div>
            <div>
              <span>Giá khôi phục file ghi âm: </span><b v-if="restoreFee">{{ restoreFee | numFormat }}</b><b v-else>{{ $t('notSet') }}</b>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 mt-1">
            <div>
              <span>Số lượng tính phí gói CDP: </span><b v-if="viberFee">{{ cdpLimit | numFormat }}</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
            <div>
              <span>Giá sử dụng dịch vụ CDP/khách hàng/tháng: </span><b v-if="cdpFee">{{ cdpFee | numFormat }}đ</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="col-md py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">Gói dịch vụ Bot</h4>
        <div class="row">
          <div class="col-6 mt-1">
            <div>
              <span>Chatbot: Giá dạy bot / 1000 ký tự: </span><b v-if="botTrainFee">{{ botTrainFee | numFormat }}</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
            <div>
              <span>Chatbot: Giá câu hỏi và câu trả lời của bot / 1000 ký tự: </span><b
                v-if="botChatFee">{{ botChatFee | numFormat }}đ</b><b
                v-else>{{ $t('notSet') }}</b>
            </div>
          </div>
          <div class="col-6 mt-1">
            <div>
              <span>Giá speed to text GPT: </span>
              <b v-if="botSpeedToTextGptFee">{{ botSpeedToTextGptFee | numFormat }}đ/phút</b>
              <b v-else>{{ $t('notSet') }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="raw row">
      <div class="col-12 py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">Chương trình giới thiệu khách</h4>
        <div class="row">
          <div class="col-md-12 mt-1">
            <span v-if="refAmount && refDeposit">
              Giới thiệu khách Callio và kiếm <b>{{ refAmount | numFormat }}<sup>đ</sup></b> cho mỗi lần đăng ký, khách giới thiệu cần nạp tối thiểu <b>{{
                refDeposit | numFormat
              }}<sup>đ</sup></b>
              <br/>
              Khách đăng ký mới bằng link giới thiệu sẽ được tặng <b>{{ refTarget | numFormat }}<sup>đ</sup></b>
            </span>
            <span v-else class="badge badge-danger">Không triển khai</span>
          </div>
        </div>
      </div>
      <div class="col-6 py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">Callio: Xuất hoá đơn tự động từ máy tính tiền</h4>
        <div class="row">
          <div class="col-md-12 mt-1">
            <span v-if="invoiceEnabled" class="badge badge-success">Tự động xuất hoá đơn khi nạp tiền</span>
            <span v-else class="badge badge-danger">Xuất hoá đơn thủ công</span>
          </div>
        </div>
      </div>
      <div class="col-6 py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">Phiên bản ứng dụng</h4>
        <div class="row">
          <div class="col-md mt-1">
            Phiên bản IOS:
            <span v-if="iosVersion" class="text-success">{{ iosVersion }}</span>
            <span v-else class="text-secondary small">Chưa cập nhật</span>
          </div>
          <div class="col-md mt-1">
            Phiên bản Android:
            <span v-if="androidVersion" class="text-success">{{ androidVersion }}</span>
            <span v-else class="text-secondary small">Chưa cập nhật</span>
          </div>
        </div>
      </div>
      <div class="col-12 py-3" style="background: #fff; font-size: 16px;" v-if="$store.state.user.role !== 'agency'">
        <h4 class="mb-1">Chức năng xuất hoá đơn điện tử</h4>
        <div class="row">
          <div class="col-md-12 mt-1">
            <span v-if="clientInvoice" class="badge badge-success">Cho phép mua / xuất hoá đơn</span>
            <span v-else class="badge badge-danger">Tắt chức năng</span>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import TimeRangePicker from "../components/TimeRangePicker";

export default {
  components: {TimeRangePicker},
  data: function () {
    return {
      count: {},
      znsFee: null,
      viberFee: null,
      aiFee: null,
      cdpFee: null,
      cdpLimit: null,
      planFee: null,
      lineFee: null,
      refAmount: null,
      refDeposit: null,
      refTarget: null,
      clientInvoice: false,
      invoiceEnabled: false,
      iosVersion: false,
      androidVersion: false,
      botTrainFee: null,
      botChatFee: null,
      botSpeedToTextGptFee: null,
      restoreFee: null,
      filterFormModel: {},
      videoEnabled: false,
      videoCcuFee: false,
    };
  },
  methods: {
    getCount() {
      if (this.$store.state.user.role !== 'agency') {
        this.$bgService.get('/dashboard/count', {params: this.filterFormModel}).then(response => {
          if (response.data) {
            this.count = response.data;
          }
        })
      }
    },
    getFees() {
      this.$bgService.get('/etc', {params: {page: 1, pageSize: 20}})
          .then(response => {
            response.data.docs.forEach(etc => {
              switch (etc.key) {
                case 'viber-fee':
                  this.viberFee = Number(etc.value);
                  break;
                case 'zns-fee':
                  this.znsFee = Number(etc.value);
                  break;
                case 'ai-fee':
                  this.aiFee = Number(etc.value);
                  break;
                case 'cdp-fee':
                  this.cdpFee = Number(etc.value);
                  break;
                case 'cdp-limit':
                  this.cdpLimit = Number(etc.value);
                  break;
                case 'plan-fee':
                  this.planFee = Number(etc.value);
                  break;
                case 'ref-amount':
                  this.refAmount = Number(etc.value);
                  break;
                case 'ref-deposit':
                  this.refDeposit = Number(etc.value);
                  break;
                case 'ref-target':
                  this.refTarget = Number(etc.value);
                  break;
                case 'invoice-enabled':
                  this.invoiceEnabled = Number(etc.value) === 1;
                  break;
                case 'mobile-android-version':
                  this.androidVersion = etc.value;
                  break;
                case 'mobile-ios-version':
                  this.iosVersion = etc.value;
                  break;
                case 'line-fee':
                  this.lineFee = etc.value;
                  break;
                case 'bot-train-fee':
                  this.botTrainFee = etc.value;
                  break;
                case 'bot-chat-fee':
                  this.botChatFee = etc.value;
                  break;
                case 'bot-speed-to-text-gpt-fee':
                  this.botSpeedToTextGptFee = etc.value;
                  break;
                case 'restore-fee':
                  this.restoreFee = etc.value;
                  break;
                case 'video-enabled':
                  this.videoEnabled = etc.value;
                  break;
                case 'video-ccu-fee':
                  this.videoCcuFee = etc.value;
                  break;
                case 'client-invoice':
                  this.clientInvoice = etc.value;
                  break;
              }
            })
          });
    },
  },
  mounted() {
    this.getCount();
    this.getFees();
    this.reloadTimerCount = setInterval(() => {
      this.getCount();
    }, 10000);
  },
  beforeDestroy: function () {
    if (this.reloadTimerCount !== null) {
      clearInterval(this.reloadTimerCount);
    }
  },
  i18n: {
    messages: {
      en: {
        overview: 'Overview',
        today: 'Today',
        user: 'User',
        new: 'New',
        online: 'Online',
        callCampaign: 'Call campaign',
        call: 'Call',
        detail: 'Detail',
        opportunity: 'Opportunity',
        callSuccess: 'Connected',
        callCampaignActive: 'Currently active',
        total: 'Total',
        connected: 'Connected',
        deposit: 'Deposit',
        spent: 'Spent',
        finance: 'Finance',
        fee: 'Service fee',
        viberFee: "Viber fee",
        znsFee: "Zns fee",
        aiFee: "Ai fee",
        notSet: 'Not set',
        cdpFee: "CDP Fee",
        lineFee: "Line Fee",
      },
      vi: {
        overview: 'Tổng quan',
        today: "Hôm nay",
        user: 'Người dùng',
        online: 'Online',
        new: 'Mới',
        callCampaign: 'Chiến dịch gọi',
        call: 'Cuộc gọi',
        detail: 'Chi tiết',
        opportunity: 'Cơ hội bán hàng',
        callSuccess: 'Kết nối thành công',
        callCampaignActive: 'Hoạt động',
        total: 'Tổng số',
        connected: 'Kết nối',
        deposit: 'Khách nạp',
        spent: 'Khách tiêu',
        finance: 'Tài chính',
        fee: 'Phí dịch vụ',
        viberFee: "Phí tin nhắn Viber tối thiểu",
        znsFee: "Phí tin nhắn ZNS tối thiểu",
        aiFee: "Phí gọi tự động tối thiểu",
        cdpFee: "Giá sử dụng dịch vụ CDP/1 khách hàng",
        notSet: 'Chưa thiết lập',
        lineFee: "Giá Line mua thêm",
      }
    }
  },
};
</script>